import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController'
import { Inject } from '@odinjs/odin';
import { AvatarAPI } from '@philips-internal/oswald-ui-components';
import {RootDoubleConferenceAliases as Alias, FragmentNames} from '../../../codegen';

@Controller({ component: Alias.DOUBLE_CONFERENCE_ROUTE_LAYOUT, fragment: FragmentNames.ROOT_DOUBLE_CONFERENCE })
export default class RootDoubleConferenceController extends BaseController {

  @Inject(Alias.AVATAR_DOUBLE_CONFERENCE)
  avatarAPI!: AvatarAPI;

  @OnMount(Alias.AVATAR_DOUBLE_CONFERENCE)
  handleMountAvatar(): void {
    const desktopNotSupported = '../../../../resources/assets/desktop_not_supported.svg';
    this.avatarAPI.setImage(desktopNotSupported);
  }
}